import { Link, Outlet } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";
import { Notifications } from "@/components/Notifications";

export const AppShell = () => (
  <div className="min-h-[100dvh] mx-auto max-w-md relative">
    <header className="sticky top-0 z-30 bg-[#F2F5FA]/85 backdrop-blur-xl px-5 pt-[max(0.75rem,env(safe-area-inset-top))] pb-3 flex items-center justify-between">
      <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5">
        <img src="/icon-192.png" alt="Gogoats" className="w-10 h-10 rounded-xl object-cover ring-2 ring-cyan-400/60 shadow-md" />
        <span className="font-display font-extrabold text-xl tracking-tight text-slate-900">GO<span className="text-cyan-500">GOATS</span></span>
      </Link>
      <Notifications />
    </header>
    <main className="px-4 pb-28 pt-1">
      <Outlet />
    </main>
    <BottomNav />
  </div>
);
